import employeePermissionReducer from './permission'
import employeeListReducer from './list'

export {employeePermissionReducer, employeeListReducer}



// WEBPACK FOOTER //
// ./app/reducers/employees/index.js